const parseIataCode = (length: number, raw?: string | null): string | undefined => {
  const code = raw?.trim().toUpperCase();
  return code && new RegExp(`^[A-Z0-9]{${length}}$`).test(code) ? code : undefined;
};

/**
 * Interpolated into BFF request paths (suggestions, lowest fares, city image), where anything but a code could reach
 * another route.
 * @example parseLocationIataCode(' cdg ') // 'CDG'
 * @example parseLocationIataCode('..%2Fapp-configuration') // undefined
 */
export const parseLocationIataCode = (raw?: string | null): string | undefined => parseIataCode(3, raw);

/**
 * @example parseAirportIataCodeList('cdg, ory,,') // ['CDG', 'ORY']
 * @example parseAirportIataCodeList('<script>,ORY') // ['ORY']
 */
export const parseAirportIataCodeList = (raw: string): string[] =>
  raw.split(',').flatMap((code) => parseIataCode(3, code) ?? []);

/**
 * @example parseAirlineIataCodeList('af, u2,,') // ['AF', 'U2']
 * @example parseAirlineIataCodeList('AFR,U2') // ['U2']
 */
export const parseAirlineIataCodeList = (raw: string): string[] =>
  raw.split(',').flatMap((code) => parseIataCode(2, code) ?? []);
